"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Aug 06 2018
 */

var Strategy_1 = require("./Strategy");
/**
 * Strategy for following one competitor.
 *
 * @author RV
 */


var SingleTargetStrategy =
/*#__PURE__*/
function (_Strategy_1$Strategy) {
  _inherits(SingleTargetStrategy, _Strategy_1$Strategy);

  /**
   * @param competitorId
   */
  function SingleTargetStrategy(competitorId) {
    var _this;

    _classCallCheck(this, SingleTargetStrategy);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleTargetStrategy).call(this));
    _this.competitorId = competitorId;
    return _this;
  }

  return SingleTargetStrategy;
}(Strategy_1.Strategy);

exports.SingleTargetStrategy = SingleTargetStrategy;